import styled, { css } from 'styled-components';

export const GridCategoryOuter = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 20px;
  padding: 40px 0 10px;
  margin: ${(props) => (props.backgroundColor ? '30px 0px' : '0')};
  background-color: ${(props) => props.backgroundColor || '#fff'};

  .grid_category {
    display: grid;
    grid-template-columns: repeat(
      ${(props) => props.mobileGridSize},
      ${(props) => 90 / props.mobileGridSize}%
    );
    column-gap: ${(props) => 10 / (props.mobileGridSize - 1)}%;
    row-gap: 20px;
    font-size: 13px;
    margin: auto;
    color: #000;
    width: 90%;

    .grid_each_category {
      display: flex;
      flex-direction: column;
      row-gap: 10px;
      align-content: center;
      align-items: center;
      text-align: center;

      .imageDes {
        font-size: clamp(12px, 2vw, 14px);
        @media (min-width: 768px) {
          max-width: 80%;
        }
      }
    }
    .image_style {
      position: relative;
      padding-top: 100%;
      width: 100%;
      img {
        border-radius: 20px;
        border: solid 1px rgba(0, 0, 0, 0);
        background-color: ${(props) => props.backgroundImageColor || '#fff'};
      }
      ${(props) =>
        props.mobileGridSize === 2 &&
        css`
          padding-top: 80%;
          width: 80%;
        `}

      ${(props) =>
        props.desktopGridSize === 3 &&
        css`
          @media (min-width: 768px) {
            padding-top: 45%;
            width: 45%;
          }
        `}
    }
    @media (min-width: 768px) {
      grid-template-columns: repeat(${(props) => props.desktopGridSize}, 22%);
      column-gap: ${(props) =>
        (100 - 22 * props.desktopGridSize) / (props.desktopGridSize - 1)}%;
      width: 70%;
    }
  }
  @media (min-width: 768px) {
    row-gap: 40px;
    padding: 40px 0;
  }
`;

export const HeadingTagCategory = styled.h2`
  width: 90%;
  margin: auto;
  margin-bottom: 10px;
  font-size: clamp(16px, 2vw, 21px);
  @media (min-width: 768px) {
    width: 80%;
  }
`;
export const HeadingTagSubCategory = styled.p`
  width: 90%;
  margin: auto;
  font-size: clamp(13px, 2vw, 15px);
  font-weight: 500;
  color: #000000c9;
  @media (min-width: 768px) {
    width: 80%;
  }
`;

export const ConsultationCategoryStyle = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 20px;
  padding-bottom: 50px;
  @media (max-width: 768px) {
    padding: 30px 0;
    margin: 10px 0 10px;
  }
  &:before {
    content: '';
    width: 100%;
    background: linear-gradient(to right, #60afa5 0%, #8ccda8 100%);
    height: 7px;
    @media (min-width: 768px) {
      width: 80%;
      margin: auto;
    }
  }
  &:after {
    content: '';
    width: 100%;
    background: #dadada;
    height: 1px;
    @media (min-width: 768px) {
      width: 80%;
      margin: auto;
    }
  }
  .consulatation_main {
    display: flex;
    column-gap: 20px;
    width: 90%;
    margin: auto;
    .image_style {
      position: relative;
      padding-top: 30%;
      flex-basis: 28%;
      width: 100%;
      img {
        border-radius: 10px;
      }
      @media (min-width: 768px) {
        padding-top: 18%;
        flex-basis: 15%;
      }
    }
    @media (min-width: 768px) {
      width: 70%;
      margin: auto;
    }
  }
  .consulatation_description {
    flex-basis: 70%;
    display: flex;
    flex-direction: column;
    row-gap: 10px;
    opacity: 0.87;
    font-size: clamp(12px, 2vw, 14px);
    button {
      display: flex;
      justify-content: center;
      padding: 8px 13px;
      border-radius: 30px;
      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.16);
      background-color: #ef4e5e;
      border: none;
      font-family: Montserrat;
      outline: none;
      font-weight: 500;
      color: white;
      width: fit-content;
      column-gap: 6px;
      img {
        transform: rotate(270deg);
      }
      @media (min-width: 768px) {
        cursor: pointer;
      }
    }
    @media (min-width: 768px) {
      flex-basis: 80%;
      row-gap: 40px;
    }
  }
  .lowOpacity {
    opacity: 0.6;
  }
  @media (min-width: 768px) {
    row-gap: 40px;
  }
`;

export const AccordionTabsCategory = styled.div`
  overflow: hidden;
  flex-grow: 1;
  flex-basis: 80%;
  @media (max-width: 768px) {
    flex-basis: 100%;
  }
`;

export const AccordianTabs = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: auto;
  padding: 10px 0;
  ${(props) =>
    props.hideHeading
      ? css`
          padding: 0;
          .tab-label {
            padding: 22px 14px;
          }
        `
      : null}
  @media (min-width: 768px) {
    width: 82%;
    ${(props) =>
      props.hideHeading
        ? css`
            width: 100%;
            padding: 0;
          `
        : null}
  }
`;

export const BookerWrapperCover = styled.div`
  width: 90%;
  margin: auto;
  @media (min-width: 768px) {
    width: 70%;
  }
`;
